// DayValue helpers — ported from dayvalue-premium.page.ts
export const UsesOfStars = [
  {StarNo:1,StarName:"அஸ்விநி",Type:"சமநோக்கு நாள்",Naming:"சு-செ-சோ-ல",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், வித்யாரம்பம், பதவி, தானியம் வாங்க, வாகனம் வாங்க, நகையணிய, புதிது உடுத்த, பயணம், மாடு-ஆடு வாங்க - விற்க"},
  {StarNo:2,StarName:"பரணி",Type:"கீழ்நோக்கு நாள்",Naming:"லி-லு-லே-லோ",Merit:"சுபம் விலக்கவும்",Works:"கதிரருக்க, மாடு-ஆடு வாங்க - விற்க, ஆயுதவேலை, மூலிகை, நோய்தீர் குளியல், சேமிக்க, அடுப்பு வைக்க"},
  {StarNo:3,StarName:"கார்த்திகை",Type:"கீழ்நோக்கு நாள்",Naming:"அ-இ-உ-எ",Merit:"சுபம் விலக்கவும்",Works:"ஆயுதவேலை, கடன்தீர்க்க, பூமிக்குகீழ் விஷயம்"},
  {StarNo:4,StarName:"ரோகிணி",Type:"மேல்நோக்கு நாள்",Naming:"ஒ-வ-வி-உ",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், விவசாயம், தானியம் வாங்க, சேமிக்க, விதைபோட, மாடு-ஆடு வாங்க - விற்க, ஆயுதவேலை, பூமிக்குகீழ் விஷயம், வாகனம் வாங்க, பயணம், தொட்டிலிட"},
  {StarNo:5,StarName:"ம்ருகசீர்ஷம்",Type:"சமநோக்கு நாள்",Naming:"வெ-வோ-கா-கி",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், விவசாயம், தானியம் வாங்க, சேமிக்க, மாடு-ஆடு வாங்க - விற்க, ஆயுதவேலை, பூமிக்குகீழ் விஷயம், வாகனம் வாங்க, பயணம், மருந்துண்ண, நோய்தீர் குளியல்"},
  {StarNo:6,StarName:"திருவாதிரை",Type:"மேல்நோக்கு நாள்",Naming:"கு-க-ஞ-ச",Merit:"பரவாயில்லை",Works:"காதுகுத்த, வித்யாரம்பம், ஆயுதவேலை, தொட்டிலிட, சேமிக்க, நோய்தீர் குளியல்"},
  {StarNo:7,StarName:"புனர்பூசம்",Type:"சமநோக்கு நாள்",Naming:"கே-கோ-ஹ-ஹி",Merit:"சுபம் செய்ய மிகநன்று",Works:"சீமந்தம், கிரஹப்ரவேசம், விவாஹம், நிஷேகம், காதுகுத்த, வித்யாரம்பம், உபதவி, பதவி, தானியம் வாங்க, வாகனம் வாங்க, ஆயுதவேலை, புதிது உடுத்த, மங்கல்யம் செய்ய, விவசாயம், மருந்துண்ண"},
  {StarNo:8,StarName:"பூசம்",Type:"மேல்நோக்கு நாள்",Naming:"ஹி-ஹே-ஹோ-ட",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், விவசாயம், தானியம் வாங்க, சேமிக்க, விதைபோட, மாடு-ஆடு வாங்க - விற்க, ஆயுதவேலை, மருந்துண்ண, நோய்தீர் குளியல், பயணம்"},
  {StarNo:9,StarName:"ஆயில்யம்",Type:"கீழ்நோக்கு நாள்",Naming:"டி-டு-டே-டோ",Merit:"சுபம் விலக்கவும்",Works:"ஆயுதப்ரயோகம், நவக்ரஹ சாந்தி செய்ய"},
  {StarNo:10,StarName:"மகம்",Type:"கீழ்நோக்கு நாள்",Naming:"ம-மி-மு-மெ",Merit:"சுபம் செய்ய நன்று",Works:"மங்கல்யம் செய்ய, விவாஹம், விதைபோட, கதிரருக்க, தானியம் வாங்க, சேமிக்க, மாடு-ஆடு வாங்க - விற்க, வாகனம் வாங்க, ஆயுதவேலை, பூமிக்குகீழ் விஷயம்"},
  {StarNo:11,StarName:"பூரம்",Type:"கீழ்நோக்கு நாள்",Naming:"மோ-ட-டி-டு",Merit:"சுபம் விலக்கவும்",Works:"ஆயுதவேலை, ப்ரா, நோய்தீர் குளியல்"},
  {StarNo:12,StarName:"உத்தரம்",Type:"மேல்நோக்கு நாள்",Naming:"டே-டோ-ப-பி",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், வித்யாரம்பம், பதவி, காதுகுத்த, விவசாயம், தானியம் வாங்க, வாகனம் வாங்க, நகையணிய, புதிது உடுத்த, பயணம்"},
  {StarNo:13,StarName:"ஹஸ்தம்",Type:"சமநோக்கு நாள்",Naming:"பு-ஷ-ந-ட",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, விவாஹம், நிஷேகம், கிரஹப்ரவேசம், உபநயனம், சீமந்தம், வித்யாரம்பம், பதவி, காதுகுத்த, விவசாயம், மாடு-ஆடு வாங்க - விற்க, நகையணிய, பயணம், மருந்துண்ண, நோய்தீர் குளியல்"},
  {StarNo:14,StarName:"சித்திரை",Type:"சமநோக்கு நாள்",Naming:"பே-போ-ர-ரி",Merit:"சுபம் செய்ய மிகநன்று",Works:"கிரஹப்ரவேசம், காதுகுத்த, வித்யாரம்பம், உபநயனம், சீமந்தம், பதவி, நிஷேகம், மாடு-ஆடு வாங்க - விற்க, வாகனம் வாங்க, தானியம் வாங்க, பூமிக்குகீழ் விஷயம், ஆயுதவேலை, மருந்துண்ண, நோய்தீர் குளியல்"},
  {StarNo:15,StarName:"ஸ்வாதி",Type:"சமநோக்கு நாள்",Naming:"ரு-ரே-ரோ-த",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், மாடு-ஆடு வாங்க - விற்க, வாகனம் வாங்க, ஆயுதவேலை, புதிது உடுத்த, தானியம் வாங்க, மருந்துண்ண"},
  {StarNo:16,StarName:"விசாகம்",Type:"கீழ்நோக்கு நாள்",Naming:"தி-து-தே-தோ",Merit:"பரவாயில்லை",Works:"விதைபோட, கதிரருக்க, தானியம் வாங்க, புதிது உடுத்த, மாடு-ஆடு வாங்க - விற்க, நோய்தீர் குளியல்"},
  {StarNo:17,StarName:"அநுஷம்",Type:"சமநோக்கு நாள்",Naming:"ந-நி-நு-நே",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, விவாஹம், நிஷேகம், உபநயனம், சீமந்தம், கிரஹப்ரவேசம், பதவி, வித்யாரம்பம், தானியம் வாங்க, வாகனம் வாங்க, ஆயுதவேலை, நகையணிய, நோய்தீர் குளியல், பயணம்"},
  {StarNo:18,StarName:"கேட்டை",Type:"சமநோக்கு நாள்",Naming:"நோ-ய-இ-யு",Merit:"சுபம் விலக்கவும்",Works:"மாடு-ஆடு வாங்க - விற்க, பூமிக்குகீழ் விஷயம், ஆயுதவேலை, நோய்தீர் குளியல்"},
  {StarNo:19,StarName:"மூலம்",Type:"கீழ்நோக்கு நாள்",Naming:"யே-யோ-ப-பி",Merit:"பரவாயில்லை",Works:"விவாஹம், நிஷேகம், கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவசாயம், விதைபோட, தானியம் வாங்க, மாடு-ஆடு வாங்க - விற்க, நோய்தீர் குளியல்"},
  {StarNo:20,StarName:"பூராடம்",Type:"கீழ்நோக்கு நாள்",Naming:"பூ-த-ப-டா",Merit:"சுபம் விலக்கவும்",Works:"ஆயுதப்ரயோகம், நவக்ரஹ சாந்தி செய்ய, கடன் தீர்க்க, மாடு-ஆடு வாங்க - விற்க, நோய்தீர் குளியல்"},
  {StarNo:21,StarName:"உத்ராடம்",Type:"மேல்நோக்கு நாள்",Naming:"பே-போ-ஜ-ஜி",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், வித்யாரம்பம், பதவி, காதுகுத்த, விவசாயம், தானியம் வாங்க, வாகனம் வாங்க, நகையணிய, புதிது உடுத்த, பயணம்"},
  {StarNo:22,StarName:"திருவோணம்",Type:"மேல்நோக்கு நாள்",Naming:"கி-குகே-கோ",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், விவசாயம், தானியம் வாங்க, சேமிக்க, விதைபோட, மாடு-ஆடு வாங்க - விற்க, ஆயுதவேலை, பூமிக்குகீழ் விஷயம், வாகனம் வாங்க, பயணம்"},
  {StarNo:23,StarName:"அவிட்டம்",Type:"மேல்நோக்கு நாள்",Naming:"க-கி-கு-கே",Merit:"சுபம் செய்ய நன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், விவசாயம், தானியம் வாங்க, சேமிக்க, மாடு-ஆடு வாங்க - விற்க, ஆயுதவேலை, பூமிக்குகீழ் விஷயம், வாகனம் வாங்க, பயணம், மருந்துண்ண, நோய்தீர் குளியல்"},
  {StarNo:24,StarName:"சதயம்",Type:"மேல்நோக்கு நாள்",Naming:"கோ-ஸ-ஸீ-ஸ",Merit:"சுபம் செய்ய நன்று",Works:"மங்கல்யம் செய்ய, விவாஹம், கிரஹப்ரவேசம், சீமந்தம், வித்யாரம்பம், தொட்டிலிட, மாடு-ஆடு வாங்க - விற்க, தானியம் வாங்க, விதைபோட, மருந்துண்ண, நோய்தீர் குளியல், பயணம்"},
  {StarNo:25,StarName:"பூரட்டாதி",Type:"கீழ்நோக்கு நாள்",Naming:"ஸே-ஸோ-தா-தீ",Merit:"சுபம் விலக்கவும்",Works:"மந்த்ர ஜபம், மாடு-ஆடு வாங்க - விற்க, நோய்தீர் குளியல்"},
  {StarNo:26,StarName:"உத்ரட்டாதி",Type:"மேல்நோக்கு நாள்",Naming:"து-ஸ-ஸ-ஸ்ரீ",Merit:"சுபம் செய்ய மிகநன்று",Works:"கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், வித்யாரம்பம், காதுகுத்த, விவசாயம், தானியம் வாங்க, வாகனம் வாங்க, பூமிக்குகீழ் விஷயம், புதிது உடுத்த, மருந்துண்ண, பயணம்"},
  {StarNo:27,StarName:"ரேவதி",Type:"சமநோக்கு நாள்",Naming:"தே-தோ-சா-சீ",Merit:"சுபம் செய்ய மிகநன்று",Works:"மங்கல்யம் செய்ய, கிரஹப்ரவேசம், உபநயனம், சீமந்தம், விவாஹம், நிஷேகம், வித்யாரம்பம், பதவி, காதுகுத்த, விவசாயம், பூமிக்குகீழ் விஷயம், வாகனம் வாங்க, நகையணிய, புதிது உடுத்த, பயணம், மாடு-ஆடு வாங்க - விற்க, மருந்துண்ண"},
];

const NAKSHATRA_NAMES = ['ரேவதி','அஸ்விநி','பரணி','கார்திகை','ரோஹிணி','ம்ருகசீர்','திருவாதிரை','புனர்வசு','பூசம்','ஆயில்யம்','மகம்','பூரம்','உத்ரம்','ஹஸ்தம்','சித்திரை','ஸ்வாதி','விசாகம்','அநுஷம்','கேட்டை','மூலம்','பூராடம்','உத்ராடம்','திருஓணம்','அவிட்டம்','சதயம்','பூரட்டாதி','உத்ரட்டாதி','ரேவதி'];
export const getNakshatraName = (n) => NAKSHATRA_NAMES[n] || 'mistake';

const RASHI_TO_STAR = {1:1,2:4,3:6,4:8,5:10,6:13,7:15,8:17,9:19,10:21,11:23,12:25};
export const getSunStar = (rashi) => RASHI_TO_STAR[rashi] || 1;

export function getMonthMerit(mno) {
  if ([4,6,9].includes(mno)) return 'சுபம் விலக்கவும்';
  return 'சுபம் செய்ய நன்று';
}

export function getDayMerit(dow) {
  // dow: 1=Sun..7=Sat
  switch(dow){
    case 3: case 7: return 'சுபம் விலக்கவும்';
    case 4: case 5: case 6: return 'சுபம் செய்ய மிகநன்று';
    default: return 'சுபம் செய்ய நன்று';
  }
}

export function getThithiMerit(paksh, TNo) {
  const p = (paksh||'').toLowerCase();
  switch(TNo){
    case 0: case 1: case 8: case 9: case 14: case 15: return 'சுபம் தவிர்க்கவும்';
    case 2: case 3: case 5: return 'சுபம் செய்ய மிகநன்று';
    case 4: return 'சுபம் செய்யலாம்';
    case 6: return 'சுபம் செய்ய நன்று';
    case 7: return p==='krishna'?'சுபம் செய்ய நன்று':'சுபம் செய்ய மிகநன்று';
    case 10: return p==='krishna'?'சுபம் செய்யலாம்':'சுபம் செய்ய மிகநன்று';
    case 11: return p==='krishna'?'சுபம் செய்யலாம்':'சுபம் செய்ய நன்று';
    case 12: return p==='krishna'?'சுபம் செய்ய நன்று':'சுபம் செய்ய மிகநன்று';
    case 13: return p==='krishna'?'சுபம் செய்யலாம்':'சுபம் செய்ய நன்று';
    default: return '';
  }
}

export function getYogaMerit(yoga) {
  if (!yoga) return '';
  if (yoga.startsWith('மரண') || yoga === 'ம') return yoga + 'யோகம் - சுபம் தவிர்க்கவும்';
  return yoga + 'யோகம் - சுபம் செய்ய நன்று';
}

export function netraPhalan(n) {
  if (n === '0' || n === 0) return 'நேத்திரம் 0 - இன்று சிறந்த முஹூர்த்தநாள் அல்ல';
  if (n === '1' || n === 1) return 'நேத்திரம் 1 - இன்று முஹூர்த்தம் செய்யலாம்';
  if (n === '2' || n === 2) return 'நேத்திரம் 2 - இன்று முஹூர்த்தம் அமைந்தால் சிறப்பு';
  return '';
}

export function jeevanPhalan(j) {
  if (j === '0' || j === 0) return 'ஜீவன் 0 - இன்று சிறந்த முஹூர்த்தநாள் அல்ல';
  if (j === '½' || j === 0.5) return 'ஜீவன் ½ - இன்று முஹூர்த்தம் செய்யலாம்';
  if (j === '1' || j === 1) return 'ஜீவன் 1 - இன்று முஹூர்த்தம் அமைந்தால் சிறப்பு';
  return '';
}

export function getKazaram(sunStarNo, todayStar) {
  let k = todayStar - sunStarNo + 1;
  if (k < 1) k += 27;
  k = k % 9;
  const noKazaram = [1,2,6,7,8];
  return { value: k, text: noKazaram.includes(k) ? 'கசரம் இல்லை' : 'கசரம் உண்டு' };
}

export function getVivahChakra(sunno, strToday) {
  const dirs = {};
  dirs.mid1 = (sunno-1)%27; dirs.mid2 = sunno; dirs.mid3 = (sunno+1)%27;
  dirs.east1 = (sunno+2)%27; dirs.east2 = (sunno+3)%27; dirs.east3 = (sunno+4)%27;
  dirs.seast1 = (sunno+5)%27; dirs.seast2 = (sunno+6)%27; dirs.seast3 = (sunno+7)%27;
  dirs.south1 = (sunno+8)%27; dirs.south2 = (sunno+9)%27; dirs.south3 = (sunno+10)%27;
  dirs.swest1 = (sunno+11)%27; dirs.swest2 = (sunno+12)%27; dirs.swest3 = (sunno+13)%27;
  dirs.west1 = (sunno+14)%27; dirs.west2 = (sunno+15)%27; dirs.west3 = (sunno+16)%27;
  dirs.nwest1 = (sunno+17)%27; dirs.nwest2 = (sunno+18)%27; dirs.nwest3 = (sunno+19)%27;
  dirs.north1 = (sunno+20)%27; dirs.north2 = (sunno+21)%27; dirs.north3 = (sunno+22)%27;
  dirs.neast1 = (sunno+23)%27; dirs.neast2 = (sunno+24)%27; dirs.neast3 = (sunno+25)%27;

  const goodDirs = ['east1','east2','east3','swest1','swest2','swest3','north1','north2','north3','neast1','neast2','neast3'];
  const isGood = goodDirs.some(k => dirs[k] === strToday);
  const chanStar = getNakshatraName(strToday);
  const result = isGood
    ? `சந்த்ர நக்ஷத்ரம் - ${chanStar} - விவாஹ சக்ரம் நன்மை தரும்`
    : `சந்த்ர நக்ஷத்ரம் - ${chanStar} - விவாஹ சக்ரம் நன்மை இல்லை`;

  // Convert numbers to names for display
  const named = {};
  for (const [k,v] of Object.entries(dirs)) {
    named[k] = k === 'mid2' ? getNakshatraName(v) + ' (சூ)' : getNakshatraName(v);
  }
  return { dirs: named, result, isGood };
}

export function getKaalam(sr, agas) {
  const srMin = Math.floor(sr)*60 + Math.round((sr%1)*100);
  const agMin = Math.floor(agas)*60 + Math.round((agas%1)*100);
  const total = agMin - srMin;
  const period = total / 5;
  const tiny = total / 15;
  const toTime = (mins) => {
    const h = Math.floor(mins/60);
    const m = Math.round(mins%60);
    return h + '.' + String(m).padStart(2,'0');
  };
  const k1 = srMin + period;
  const k2 = k1 + period;
  const k3 = k2 + period;
  const k4 = k3 + period;
  const k5 = k4 + period;
  const kutapaFrom = srMin + tiny * 7;
  const kutapaEnd = kutapaFrom + tiny;
  return {
    prathah: toTime(srMin) + ' To ' + toTime(k1),
    sangava: toTime(k1) + ' To ' + toTime(k2),
    madhyahna: toTime(k2) + ' To ' + toTime(k3),
    aparahna: toTime(k3) + ' To ' + toTime(k4),
    saayahna: toTime(k4) + ' To ' + toTime(k5),
    sangavaEnd: toTime(k2),
    kutapaFrom: toTime(kutapaFrom),
    kutapaEnd: toTime(kutapaEnd),
    madhyahnaEnd: toTime(k3),
  };
}
